// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customBorder[data-v-184343c8]{width:100%;border-bottom:1px solid #dbdee3}.diagonalLine[data-v-184343c8]{position:absolute;right:-8px;width:24px;height:8px;background:#f2f3f5;transform:rotate(-45deg)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
